
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/assignment-index/jst/AssignmentSettings';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n  <span class=\"ag-weights-message alert\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_settings")
  },data:data},helper ? helper.call(depth0, "assignment_group_weights_can_t_be_edited_because_t_b6b591ae", "Assignment group weights can't be edited because there are assignments in one of the groups whose due dates are closed.", options) : helperMissing.call(depth0, "t", "assignment_group_weights_can_t_be_edited_because_t_b6b591ae", "Assignment group weights can't be edited because there are assignments in one of the groups whose due dates are closed.", options)))
    + "</span>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "apply_assignment_group_weights", options) : helperMissing.call(depth0, "checkbox", "apply_assignment_group_weights", options)))
    + "\n    ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{
    'class': ("disabled"),
    'readonly': (true)
  },data:data},helper ? helper.call(depth0, "apply_assignment_group_weights", options) : helperMissing.call(depth0, "checkbox", "apply_assignment_group_weights", options)))
    + "\n    ";
  return buffer;
  }

function program7(depth0,data) {
  
  
  return "disabled";
  }

function program9(depth0,data) {
  
  
  return "aria-disabled=true";
  }

  buffer += "<div class=\"form-dialog-content ag-weights-content\">\n  ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeWeights), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <label class=\"checkbox\" id=\"weight-groups\" for=\"apply_assignment_group_weights\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.canChangeWeights), {hash:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_settings")
  },data:data},helper ? helper.call(depth0, "weight_final_grade_based_on_assignment_groups_3124161", "Weight final grade based on assignment groups", options) : helperMissing.call(depth0, "t", "weight_final_grade_based_on_assignment_groups_3124161", "Weight final grade based on assignment groups", options)))
    + "\n  </label>\n\n  <div class=\"form-horizontal ag-weights-form\">\n    <div id=\"ag_weights_wrapper\" class=\"ag-weights-table\">\n      <table id=\"assignment_groups_weights\">\n        <tbody>\n        </tbody>\n        <tfoot>\n          <tr>\n            <th scope=\"row\">Total</th>\n            <td id=\"percent_total\" class=\"right-align\"></td>\n          </tr>\n        </tfoot>\n      </table>\n    </div>\n  </div>\n</div>\n\n<div class=\"form-controls\">\n  <button\n    id=\"cancel-assignment-settings\"\n    class=\"btn dialog_closer ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeWeights), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n    type=\"button\"\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeWeights), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_settings")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "</button>\n  <button\n    id=\"update-assignment-settings\"\n    class=\"btn btn-primary ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeWeights), {hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\"\n    data-text-while-loading='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_settings")
  },data:data},helper ? helper.call(depth0, "saving_d55dd90e", "Saving...", options) : helperMissing.call(depth0, "t", "saving_d55dd90e", "Saving...", options)))
    + "'\n    type=\"submit\"\n    ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.canChangeWeights), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  >"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("assignments.assignment_settings")
  },data:data},helper ? helper.call(depth0, "save_11a80ec3", "Save", options) : helperMissing.call(depth0, "t", "save_11a80ec3", "Save", options)))
    + "</button>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  